export const showLoadingType = 'LOADING_SHOW';
export const clearLoadingType = 'LOADING_CLEAR';
